import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ModalLayout } from '@appbase/templates'
import GridView from '@appbase/components/GridView/GridView.vue';

@Component({
    components: {
        ModalLayout,
        GridView
    }
})
export default class AttendanceManageModal extends Vue {
    keyword: string = '';

    headers: Array<gridView.Header> = [
        { displayName: this.$t('이름').toString(), rowKey: 'displayName', width: '100', align: 'center' },
        { displayName: this.$t('사번').toString(), rowKey: 'personId', width: '120', align: 'center' },
    ];
    userList: gridView.ModelItem<any>[] = [];
    checkedUsers: any[] = [];
    selectedUsers: any[] = [];


    handleClose() {
        this.closeCurrentModal();
    }

    onSearch() {

    }
}